import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Image from "../components/image"

const IndexPage = () => {
  return (
    <Layout>
      <SEO title="Home" />
      {/* <h1 className="title">Love2Donate</h1> */}
      <div className="logoContainer">
        <div className="logo">
          <Image />
        </div>
      </div>
    </Layout>
  )
}

export default IndexPage
